/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError:false };
	}

	static getDerivedStateFromError(/*error*/) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		const { logger } = this.props;
		if(logger) {
			// logging error message
			logger.error(errorInfo.componentStack /* information about which component threw the error. */);
		}
	}

	render() {
		if (this.state.hasError) {
			// TODO: error screen when we encounter error
			return null;
		}
		return this.props.children;
	}
}

ErrorBoundary.propTypes = {
	logger: PropTypes.object.isRequired,
	children: PropTypes.any
};

ErrorBoundary.defaultProps = {
	children: []
};
export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/js/ErrorBoundary.js